
import { I18N } from 'aurelia-i18n';
import { autoinject } from 'aurelia-framework';

@autoinject
export class ValueToFormatedCurrencyBaseValueConverter {
  protected i18n: I18N = null;
  protected locale: string;
  constructor(i18n: I18N) {

    this.locale = i18n.getLocale().toLowerCase();
  }

  toView(value, currency) {
    return value != undefined ? value.toLocaleString("cs-CZ") + currency : value;//"cs-CZ"
  }
}